import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatedString } from 'models/translated-string';

/**
 * CsEmptyStateComponent provides an empty state UI pattern for when no data is available
 *
 * Usage:
 * <cs-empty-state
 *   iconName="home"
 *   title="Choose a Template to Begin"
 *   subtext="Select an equipment template above to unlock additional fields and create your new equipment type.">
 *   <!-- Optional button content -->
 *   <cs-button>Button CTA</cs-button>
 * </cs-empty-state>
 */
@Component({
    selector: 'cs-empty-state',
    templateUrl: 'cs-empty-state.html',
    host: { 'class': 'empty-state' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsEmptyStateComponent {
  @Input() iconName: string;
  @Input() title: TranslatedString;
  @Input() subtext: TranslatedString;
}